// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homePage[data-v-da920a76] {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background-color: #f0f0f0;\n}\n.homePage .homePageLeft[data-v-da920a76] {\n    height: 100%;\n}\n.homePage .homePageRight[data-v-da920a76] {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n.homePage .main[data-v-da920a76] {\n    width: 100%;\n    height: calc(100% - 40px);\n    padding: 20px;\n    box-sizing: border-box;\n    overflow-x: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
